import React, { Component } from "react";
import { UiWhiteCard } from "../_uiComponents/common/UiWhiteCard";
import { UiDashboardEmptyMessage } from "../_uiComponents/ErrorMessages/UiEmptyScreens";
import emptyscreenDashboard from "../../styles/img/empty-accounts-db.png";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      redirect: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  handleRedirect = () => {
    this.setState({ redirect: true });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="df-db-left">
          <UiWhiteCard className="mt-0 df-mh-wf df-pad-30">
            {" "}
            <UiDashboardEmptyMessage
              icon={emptyscreenDashboard}
              className="df-fs-empt df-empt-msg-acc"
            >
              <h3>Something went wrong!</h3>
              <p>Sorry, an unexpected error occurred.</p>
            </UiDashboardEmptyMessage>
          </UiWhiteCard>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
